// src/pages/SupplierDue/components/exportSupplierDueCsv.js
import commaNumber from "comma-number";

const format = commaNumber.bindWith(",", ".");
const escape = (val) => {
  const str = String(val ?? "");
  return str.includes(",") || str.includes('"') || str.includes("\n")
    ? `"${str.replace(/"/g, '""')}"`
    : str;
};
const fmtNum = (val) => format(parseFloat(val || 0).toFixed(2));

/**
 * @param {object} params
 * @param {Array}   params.list          - rows from Redux state.supplierDue.list
 * @param {number}  params.totalBalance  - from Redux state.supplierDue.totalBalance
 * @param {string}  params.title
 * @param {string}  params.filename
 */
export const exportSupplierDueCsv = ({
  list,
  totalBalance,
  title    = "Supplier Due Balance Report",
  filename = "supplier_due_balance",
}) => {
  const headers = [
    "No.", "Supplier Name", "Contact No", "Address",
    "Opening", "Bill Amount", "Payment", "Received", "Return", "Balance",
  ].map(escape);

  const dataRows = list.map((row, i) => [
    i + 1,
    row.acc_name         || "",
    row.contact_no       || "",
    row.address          || "",
    fmtNum(row.opening_balance),
    fmtNum(row.total_bill_amount),
    fmtNum(row.total_pay_amount),
    fmtNum(row.received_total),
    fmtNum(row.return_amount),
    fmtNum(row.balance),
  ].map(escape));

  const totals = list.reduce((acc, row) => ({
    opening:    acc.opening    + parseFloat(row.opening_balance   || 0),
    billAmount: acc.billAmount + parseFloat(row.total_bill_amount || 0),
    payment:    acc.payment    + parseFloat(row.total_pay_amount  || 0),
    received:   acc.received   + parseFloat(row.received_total    || 0),
    return:     acc.return     + parseFloat(row.return_amount     || 0),
  }), { opening: 0, billAmount: 0, payment: 0, received: 0, return: 0 });

  const totalRow = [
    "Grand Total", "", "", "",
    fmtNum(totals.opening),
    fmtNum(totals.billAmount),
    fmtNum(totals.payment),
    fmtNum(totals.received),
    fmtNum(totals.return),
    fmtNum(totalBalance),
  ].map(escape);

  const rows = [[title], [], headers, ...dataRows, [], totalRow];

  const csv  = rows.map((r) => r.join(",")).join("\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement("a");
  a.href     = url;
  a.download = `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};